export const TARGET_THRESHOLD = 1.5;
export const BAD_THRESHOLD = 1;